import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectTemplateList = createSelector(
  [(store: RootState) => store.massiveDocumentCreate.templateList],
  (list) => list
);
